// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container__vk_66","faqContent":"page_faqContent___p_aS","noFAQsContainer":"page_noFAQsContainer__6uMCZ"};